(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/tipsinfo/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/sport/tipsinfo/javascripts/prescript.js');

'use strict';

(function(svs) {
  svs = svs || {};
  svs.sport = svs.sport || {};
  svs.sport.tipsinfo = svs.sport.tipsinfo || {};
})(svs);


 })(window);